export default "__VITE_ASSET__fda20a00__"